import cleanDeep from 'clean-deep'

import { Video } from '~/components/Metadata/Metadata.types'

import { LevelPageDetailsType } from '~/bootcamp/types/bootcamp.types'

import Schema from './Schema'
import { organizationSchema, toPlainText } from './Schema.util'
import { Element } from './Schema.types'
interface Props {
  video: Video
  details: LevelPageDetailsType
}

function createSchemaObject(video: Video, details: LevelPageDetailsType): any {
  return cleanDeep({
    '@context': 'https://schema.org',
    '@type': ['VideoObject', 'LearningResource'],
    encodingFormat: 'text/markdown',
    name: details.sectionName,
    description: toPlainText(details.content as Element[]),
    thumbnailUrl: video.thumbnailUrl,
    uploadDate: video.uploadDate,
    duration: video.duration,
    genre: video.genre,
    contentUrl: video.url,
    learningResourceType: 'Concept Overview',
    author: organizationSchema,
  })
}

const VideoSchema = ({ video, details }: Props): React.ReactElement => {
  const schemaObject = createSchemaObject(video, details)

  return <Schema schemaObject={schemaObject} />
}

export default VideoSchema
